import "./datepickerComponent.css";
import PropTypes from "prop-types";
import { FormLabel, FormGroup, Form } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";

const DatepickerComponent = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  setDateRange,
}) => {
  const handleChangeStart = (date) => {
    setStartDate(moment(date).format());
    setDateRange("Custom");
  };

  const handleChangeEnd = (date) => {
    setEndDate(moment(date).format());
    setDateRange("Custom");
  };

  const gridComponent = (
    <>
      <Form className="form-inline">
        <div className="row-datepicker">
          <FormGroup className="form-group">
            <FormLabel className="date-form-label">Start Date:</FormLabel>
            <DatePicker
              title="start date picker"
              name="start date"
              selected={moment(startDate).toDate()}
              selectsStart
              startDate={moment(startDate).toDate()}
              endDate={endDate}
              onChange={handleChangeStart.bind(this)}
            />
          </FormGroup>
          <FormGroup className="form-group">
            <FormLabel className="date-form-label">End Date:</FormLabel>
            <DatePicker
              title="end date picker"
              name="end date"
              selected={moment(endDate).toDate()}
              selectsEnd
              startDate={moment(startDate).toDate()}
              endDate={moment(endDate).toDate()}
              onChange={handleChangeEnd.bind(this)}
            />
          </FormGroup>
        </div>
      </Form>
    </>
  );

  return <div>{gridComponent}</div>;
};

DatepickerComponent.propTypes = {
  startDate: PropTypes.instanceOf(moment),
  endDate: PropTypes.instanceOf(moment),
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
  setDateRange: PropTypes.func.isRequired,
};

export default DatepickerComponent;
